var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDailyReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.878,
    height: 30.721,
    viewBox: "0 0 52.878 71.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9090",
    "data-name": "Group 9090",
    transform: "translate(-1433.162 -195.183)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4539",
    "data-name": "Rectangle 4539",
    width: 38.416,
    height: 52.253,
    rx: 0.928,
    transform: "translate(1447.375 214.4)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9086",
    "data-name": "Group 9086",
    transform: "translate(1453.496 223.852)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    x2: 8.83,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    x2: 7.173,
    transform: "translate(21.54 0)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    x2: 5.513,
    transform: "translate(0 2.844)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    x2: 5.513,
    transform: "translate(6.594 2.844)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    x2: 3.242,
    transform: "translate(0 7.21)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    x2: 13.407,
    transform: "translate(4.378 7.21)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    x2: 9.89,
    transform: "translate(18.7 7.21)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    x1: 4.521,
    transform: "translate(24.069 11.494)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    x1: 10.338,
    transform: "translate(12.501 11.494)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    x1: 11.509,
    transform: "translate(0 11.494)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    x1: 3.242,
    transform: "translate(25.348 20.761)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    x1: 13.407,
    transform: "translate(10.806 20.761)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x1: 9.89,
    transform: "translate(0 20.761)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    x2: 4.521,
    transform: "translate(0 16.477)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    x2: 10.338,
    transform: "translate(5.752 16.477)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x2: 11.509,
    transform: "translate(17.081 16.477)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    x2: 4.575,
    transform: "translate(15.208 25.044)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x2: 8.107,
    transform: "translate(20.483 25.044)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x2: 5.209,
    transform: "translate(0 25.044)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    x2: 5.799,
    transform: "translate(6.991 25.044)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    x1: 3.242,
    transform: "translate(25.348 33.611)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    x1: 13.407,
    transform: "translate(10.806 33.611)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    x1: 9.89,
    transform: "translate(0 33.611)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    x2: 4.521,
    transform: "translate(0 29.328)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    x2: 10.338,
    transform: "translate(5.752 29.328)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    x2: 11.509,
    transform: "translate(17.081 29.328)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    x2: 4.575,
    transform: "translate(15.208 37.894)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_293",
    "data-name": "Line 293",
    x2: 8.107,
    transform: "translate(20.483 37.894)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    x2: 5.209,
    transform: "translate(0 37.894)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    x2: 5.799,
    transform: "translate(6.991 37.894)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4540",
    "data-name": "Rectangle 4540",
    width: 38.416,
    height: 52.253,
    rx: 0.928,
    transform: "translate(1439.739 207.62)",
    fill: "#fff",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9087",
    "data-name": "Group 9087",
    transform: "translate(1445.86 217.068)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x2: 8.83,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    x2: 7.173,
    transform: "translate(21.54 0)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    x2: 5.513,
    transform: "translate(0 2.844)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    x2: 5.513,
    transform: "translate(6.594 2.844)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    x2: 3.242,
    transform: "translate(0 7.21)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    x2: 13.407,
    transform: "translate(4.378 7.21)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    x2: 9.89,
    transform: "translate(18.7 7.21)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    x1: 4.521,
    transform: "translate(24.069 11.494)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    x1: 10.338,
    transform: "translate(12.501 11.494)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    x1: 11.509,
    transform: "translate(0 11.494)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x1: 3.242,
    transform: "translate(25.348 20.761)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x1: 13.407,
    transform: "translate(10.806 20.761)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    x1: 9.89,
    transform: "translate(0 20.761)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_309",
    "data-name": "Line 309",
    x2: 4.521,
    transform: "translate(0 16.477)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310",
    "data-name": "Line 310",
    x2: 10.338,
    transform: "translate(5.752 16.477)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_311",
    "data-name": "Line 311",
    x2: 11.509,
    transform: "translate(17.081 16.477)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312",
    "data-name": "Line 312",
    x2: 4.575,
    transform: "translate(15.208 25.044)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_313",
    "data-name": "Line 313",
    x2: 8.107,
    transform: "translate(20.483 25.044)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_314",
    "data-name": "Line 314",
    x2: 5.209,
    transform: "translate(0 25.044)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315",
    "data-name": "Line 315",
    x2: 5.799,
    transform: "translate(6.991 25.044)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    x1: 3.242,
    transform: "translate(25.348 33.611)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    x1: 13.407,
    transform: "translate(10.806 33.611)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    x1: 9.89,
    transform: "translate(0 33.611)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    x2: 4.521,
    transform: "translate(0 29.328)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    x2: 10.338,
    transform: "translate(5.752 29.328)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    x2: 11.509,
    transform: "translate(17.081 29.328)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    x2: 4.575,
    transform: "translate(15.208 37.894)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x2: 8.107,
    transform: "translate(20.483 37.894)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    x2: 5.209,
    transform: "translate(0 37.894)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    x2: 5.799,
    transform: "translate(6.991 37.894)",
    fill: "none",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4541",
    "data-name": "Rectangle 4541",
    width: 38.416,
    height: 52.253,
    rx: 0.928,
    transform: "translate(1433.162 200.168)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9088",
    "data-name": "Group 9088",
    transform: "translate(1438.481 207.619)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    x2: 7.647,
    transform: "translate(0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x2: 7.173,
    transform: "translate(21.54 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    x2: 3.548,
    transform: "translate(0 2.844)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    x2: 3.639,
    transform: "translate(8.467 2.844)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_330",
    "data-name": "Line 330",
    x2: 3.242,
    transform: "translate(0.001 7.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_331",
    "data-name": "Line 331",
    x2: 13.407,
    transform: "translate(4.378 7.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    x2: 9.89,
    transform: "translate(18.7 7.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x1: 4.521,
    transform: "translate(24.069 11.494)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x1: 10.338,
    transform: "translate(12.501 11.494)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x1: 11.509,
    transform: "translate(0.001 11.494)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    x1: 3.242,
    transform: "translate(25.348 20.761)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x1: 13.407,
    transform: "translate(10.806 20.761)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_338",
    "data-name": "Line 338",
    x1: 9.89,
    transform: "translate(0 20.761)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_339",
    "data-name": "Line 339",
    x2: 4.521,
    transform: "translate(0 16.478)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_340",
    "data-name": "Line 340",
    x2: 10.338,
    transform: "translate(5.752 16.478)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341",
    "data-name": "Line 341",
    x2: 11.509,
    transform: "translate(17.081 16.478)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    x2: 4.575,
    transform: "translate(15.208 25.044)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    x2: 8.107,
    transform: "translate(20.483 25.044)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x2: 5.209,
    transform: "translate(0 25.044)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x2: 5.799,
    transform: "translate(6.991 25.044)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    x1: 3.242,
    transform: "translate(25.348 33.611)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    x1: 13.407,
    transform: "translate(10.806 33.611)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x1: 9.89,
    transform: "translate(0 33.611)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    x2: 4.521,
    transform: "translate(0 29.328)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    x2: 10.338,
    transform: "translate(5.752 29.328)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351",
    "data-name": "Line 351",
    x2: 11.509,
    transform: "translate(17.081 29.328)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    x2: 4.575,
    transform: "translate(15.208 37.894)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x2: 8.107,
    transform: "translate(20.483 37.894)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x2: 5.209,
    transform: "translate(0 37.894)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 5.799,
    transform: "translate(6.991 37.894)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9089",
    "data-name": "Group 9089",
    transform: "translate(1456.953 196.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3034",
    "data-name": "Path 3034",
    transform: "translate(-624.444 -228.238)",
    fill: "#113252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 625.6568603515625 249.2095489501953 C 624.71240234375 249.2095489501953 623.944091796875 248.4459686279297 623.944091796875 247.5074310302734 L 623.944091796875 244.9706878662109 C 623.944091796875 244.515380859375 624.1229858398438 244.0875244140625 624.4478759765625 243.7659301757812 L 634.952880859375 233.3638458251953 C 635.2767333984375 233.0431518554688 635.7066040039062 232.8665313720703 636.1633911132812 232.8665313720703 C 636.6201171875 232.8665313720703 637.050048828125 233.0431518554688 637.3739013671875 233.3638458251953 L 639.7857055664062 235.7523193359375 C 640.1107788085938 236.0735321044922 640.2899780273438 236.501708984375 640.2899780273438 236.9576110839844 C 640.2899169921875 237.4134979248047 640.1107177734375 237.8416290283203 639.7853393554688 238.1631317138672 L 629.2555541992188 248.5909423828125 C 628.9541015625 248.8890533447266 628.5553588867188 249.064453125 628.1325073242188 249.0850830078125 L 625.7462768554688 249.2072601318359 C 625.71630859375 249.2087860107422 625.6864624023438 249.2095489501953 625.6568603515625 249.2095489501953 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.1633911132812 233.3665313720703 C 635.8527221679688 233.3665313720703 635.5420532226562 233.4840698242188 635.3046875 233.7191314697266 L 624.7996215820312 244.1212615966797 C 624.5717163085938 244.3468780517578 624.444091796875 244.6519927978516 624.444091796875 244.9706878662109 L 624.444091796875 247.5074310302734 C 624.444091796875 248.1959533691406 625.0267944335938 248.7430725097656 625.720703125 248.7079010009766 L 628.108154296875 248.5856781005859 C 628.4078369140625 248.5710601806641 628.6914672851562 248.4456024169922 628.9037475585938 248.2356719970703 L 639.4338989257812 237.8074798583984 C 639.9086303710938 237.3383941650391 639.9086303710938 236.5767364501953 639.4338989257812 236.1075897216797 L 637.0220947265625 233.7191314697266 C 636.78466796875 233.4840698242188 636.4739990234375 233.3665313720703 636.1633911132812 233.3665313720703 M 636.1633911132812 232.3665313720703 C 636.7527465820312 232.3665313720703 637.3076171875 232.5945434570312 637.7257080078125 233.008544921875 L 640.1375732421875 235.3970489501953 C 640.5580444335938 235.8125610351562 640.7899780273438 236.3670501708984 640.7899780273438 236.9576416015625 C 640.7899169921875 237.5482025146484 640.5579223632812 238.1026306152344 640.1367797851562 238.518798828125 L 629.607421875 248.9462127685547 C 629.2179565429688 249.3313446044922 628.7030029296875 249.5578460693359 628.1568603515625 249.5844879150391 L 625.7718505859375 249.7065887451172 C 625.7332763671875 249.7085723876953 625.695068359375 249.7095336914062 625.6567993164062 249.7095336914062 C 624.4367065429688 249.7095336914062 623.444091796875 248.7216796875 623.444091796875 247.5074310302734 L 623.444091796875 244.9706878662109 C 623.444091796875 244.380859375 623.6756591796875 243.8267974853516 624.0961303710938 243.4105834960938 L 634.60107421875 233.0085601806641 C 635.0191040039062 232.5945587158203 635.573974609375 232.3665313720703 636.1633911132812 232.3665313720703 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3272",
    "data-name": "Path 3272",
    transform: "translate(16.363 0) rotate(44.996)",
    fill: "#113252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.19634473323822 6.327682971954346 C 0.7408046722412109 6.327682971954346 0.3135446906089783 6.15043306350708 -0.006745319347828627 5.828582763671875 C -0.3270353078842163 5.506732940673828 -0.5021952986717224 5.078542709350586 -0.499975323677063 4.6228928565979 L -0.483435332775116 1.228222966194153 C -0.4788653254508972 0.2889829277992249 0.2889846861362457 -0.4788670837879181 1.228224635124207 -0.4834370911121368 L 4.623034477233887 -0.4999770820140839 L 4.631484508514404 -0.499997079372406 C 5.087024688720703 -0.499997079372406 5.514284610748291 -0.3227470815181732 5.834574699401855 -0.000897083489689976 C 6.15486478805542 0.3209529221057892 6.330024719238281 0.7491429448127747 6.327804565429688 1.204792857170105 L 6.311264514923096 4.599462985992432 C 6.306694507598877 5.538702964782715 5.538844585418701 6.306552886962891 4.599604606628418 6.311122894287109 L 1.204794645309448 6.327662944793701 L 1.19634473323822 6.327682971954346 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.631484985351562 -1.9073486328125e-06 C 4.629491806030273 -1.9073486328125e-06 4.62747049331665 3.337860107421875e-06 4.62547492980957 1.287460327148438e-05 L 1.230664730072021 0.01655292510986328 C 0.5633745193481445 0.01980304718017578 0.01980447769165039 0.5633831024169922 0.01655483245849609 1.230662822723389 L 1.478195190429688e-05 4.625332832336426 C -0.003235816955566406 5.292622566223145 0.5348930358886719 5.830923080444336 1.202354907989502 5.827672958374023 L 4.597164630889893 5.811132907867432 C 5.264444828033447 5.807882785797119 5.808024883270264 5.264302730560303 5.811274528503418 4.597023010253906 L 5.82781457901001 1.202353000640869 C 5.831055164337158 0.5370588302612305 5.296006202697754 -1.9073486328125e-06 4.631484985351562 -1.9073486328125e-06 M 4.631484508514404 -0.9999971389770508 C 5.221034526824951 -0.9999971389770508 5.77416467666626 -0.7704272270202637 6.188984870910645 -0.3535871505737305 C 6.603804588317871 0.06325292587280273 6.830674648284912 0.6175627708435059 6.827804565429688 1.207222938537598 L 6.811264514923096 4.601892948150635 C 6.805354595184326 5.814162731170654 5.814304828643799 6.80521297454834 4.602034568786621 6.811122894287109 L 1.19634485244751 6.827682971954346 C 0.6067948341369629 6.827682971954346 0.0536646842956543 6.598113059997559 -0.3611555099487305 6.181272983551025 C -0.775975227355957 5.764432907104492 -1.002845287322998 5.210123062133789 -0.9999752044677734 4.620462894439697 L -0.9834351539611816 1.22579288482666 C -0.9775252342224121 0.01352310180664062 0.01352453231811523 -0.9775271415710449 1.225794792175293 -0.9834370613098145 L 4.631484508514404 -0.9999971389770508 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyReportIcon);
export default __webpack_public_path__ + "static/media/dailyReportIcon.ad72d40e5afd094fe457f9ee7ea01ba5.svg";
export { ForwardRef as ReactComponent };